import { render } from "./ModalViewUser.vue?vue&type=template&id=5db6029e"
import script from "./ModalViewUser.vue?vue&type=script&lang=js"
export * from "./ModalViewUser.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__